import { Fancybox } from '@fancyapps/ui';
export default function () {

    var mainItem = document.querySelector("[data-mass-action-type]");
    if (mainItem == null)
        return;

    var massActionType = mainItem.dataset.massActionType;
    var storageKey = `massAction_storage_${massActionType}`;

    document.querySelectorAll('.mass-action-item').forEach(checkboxItem => {
        checkboxItem.addEventListener('click', function () {
            toggleMassActionItem(checkboxItem.dataset.itemId, checkboxItem.dataset.itemType);
            redrawItems();

        });
    });

    function openMassAction(event) {
        event.preventDefault();

        Fancybox.show(
            [
                {
                    src: this.href,
                    type: 'iframe',
                },
            ],
            {
                showClass: 'open-popup-iframe-wrapper',
                dragToClose: false,
                closeButton: false
            }
        );
    }

    if (document.querySelector("#actionTarget")) {
        
        document.querySelector("#actionTarget")
                .replaceWith(document.querySelector("#actionTarget").cloneNode(true));
        
        document.querySelector("#actionTarget").addEventListener('click', openMassAction);
    }

    if (document.querySelector(".unselect-all-rows")) {
        document.querySelector(".unselect-all-rows").addEventListener('click', function () {

            localStorage.setItem(storageKey, JSON.stringify([]));
            redrawItems();
        });
    }

    document.querySelector("[data-rows-toggle]").addEventListener('click', function () {

        document.querySelectorAll(".mass-action-item").forEach(toggleItem => {
            toggleItem.click();
        });

    });



    function getCurrentItems() {


        const currentStorage = localStorage.getItem(storageKey);

        if (currentStorage == null)
            return [];

        return JSON.parse(currentStorage);
    }

    function redrawItems() {

        let items = getCurrentItems();

        document.querySelectorAll('.mass-action-item').forEach(item => {

            var id = item.dataset.itemId;
            var exists = items.includes(id);


            item.querySelector("input").checked = exists;
            item.dataset.itemSelected = exists ? 'on' : 'off';

        });

        updateActionWindow();

    }

    function toggleMassActionItem(id, type) {

        let items = getCurrentItems();

        if (!items.includes(id))
            items.push(id);
        else
            items = items.filter(x => x !== id);

        localStorage.setItem(storageKey, JSON.stringify(items));


    }


    redrawItems();



    function updateActionWindow() {
        var userActionBox = $('.user-action-box');
        var items = getCurrentItems();

        if (!(userActionBox.length > 0))
            return;

        if (items.length > 0)
            $('body').addClass('showBox');
        else $('body').removeClass('showBox');

        userActionBox.find('span#actionInfo').attr('data-amount', items.length);

        var actionItems = document.querySelector("#actionItems");
        if (actionItems != null)
            actionItems.value = items.join('|');


        var existing = userActionBox.find("a#actionTarget").attr("href");
        var href = new URL(existing);
        href.searchParams.set('items', items.join('|'));

        userActionBox.find("a#actionTarget").attr('href', href.toString());
    }
}